/* eslint-disable security/detect-object-injection */
import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './styles.css';
import AnimatedImage from '../Animations/AnimatedImage';
import moment from 'moment-timezone';

export default function CarouselComponent(props) {
    const { data, setCurrentAppointment, setAppointments, currentAppointment } = props;
    const handleSwapAppointment = (index1, index2, appointment) => {
        let temp = currentAppointment;
        setCurrentAppointment(appointment);
        data[index1][index2] = temp;
        setAppointments([...data]); 
    }

    return (
        <Carousel
            autoPlay={false}
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            showIndicators={data.length > 1 ? true : false}
        >
            {data.map((item, index) => (
                <div key={`"slide${index+1}"`}>
                    <div className='flex' onClick={() => handleSwapAppointment(index, 0, item[0])}>
                        <div className='bg-[#9013FE] flex flex-col items-center justify-center w-[25%] rounded-lg relative -left-[2px]'>
                            <p className='text-[#F2F2F2] text-[32px] font-semibold text-center fold-text'>{moment(item[0].appointment_date).format('DD')}</p>
                            <p className='text-[#F2F2F2] text-[24px] font-semibold text-center fold-text'>{moment(item[0].appointment_date).format('MMM')}</p>
                        </div>
                        <div className='w-[75%] mx-[10px] py-[10px]'>
                            <p className='text-[#007EB4] flex font-semibold text-base items-start fold-normal-text max-w-[142px] break-all'>
                                <AnimatedImage url="/images/Doctor.svg" alt="doctor" className="mr-[12px] icon" />
                                {item[0].doctor_name || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-words mt-3 fold-normal-text'>
                                <AnimatedImage url="/images/Time.svg" alt="time" className="mr-[12px] icon" />
                                {`${moment(item[0].appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}` || '---'}
                            </p>
                        </div>
                    </div>
                    {item[1] && <div className='flex mt-[24px]' onClick={() => handleSwapAppointment(index, 1, item[1])}>
                        <div className='bg-[#F59B22] flex flex-col items-center justify-center w-[25%] rounded-lg relative -left-[2px] ml-[2px]'>
                            <p className='text-[#F2F2F2] text-[32px] font-semibold text-center fold-text'>{moment(item[1].appointment_date).format('DD')}</p>
                            <p className='text-[#F2F2F2] text-[24px] font-semibold text-center fold-text'>{moment(item[1].appointment_date).format('MMM')}</p>
                        </div>
                        <div className='w-[75%] mx-[10px] py-[10px]'>
                            <p className='text-[#007EB4] flex font-semibold text-base items-start fold-normal-text max-w-[142px] break-all'>
                                <AnimatedImage url="/images/Doctor.svg" alt="doctor" className="mr-[12px] icon" />
                                {item[1].doctor_name || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-words mt-3 fold-normal-text'>
                                <AnimatedImage url="/images/Time.svg" alt="time" className="mr-[12px] icon" />
                                {`${moment(item[1].appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}` || '---'}
                            </p>
                        </div>
                    </div>}
                </div>
            ))}
        </Carousel>
    );
};